
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from 'components/MDButton';
import Select from 'react-select';
import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
// import { Alert } from "bootstrap";
import * as service from '../../../../services/service';

function AddEditMaterialSubCategory() {
    const [state, setState] = useState({ materialsubcategory: '', materialsubcategorycode: '' });
    const [materialCategoryId, setMaterialCategoryId] = useState('');
    const [materialCategoryData, setMaterialCategoryData] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };

    const navigate = useNavigate();
    const params = useParams();
    const getMaterialCategories = () => {
        fetch(
            service.MATERIAL_CATEGORY_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.materialCategoryId, label: item.materialCategory }));
                setMaterialCategoryData(data2);
            });
    };

    const getDetailsById = () => {
        setLoading(true);
        const errs = {};
        if (params.id > 0) {
            fetch(
                service.GET_MATERIAL_SUB_CATEGORY_BY_ID,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        MaterialSubCategoryId: params.id,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.message.messageType === 'Success') {
                        setState({ ...state, materialsubcategory: result.materialSubCategory, materialsubcategorycode: result.materialSubCategoryCode });
                        const data = ({ value: result.materialCategoryId, label: result.materialCategory });
                        setMaterialCategoryId(data);

                        localStorage.setItem('materialCategoryId', JSON.stringify(result.materialCategoryId));
                        localStorage.setItem('materialCategory', JSON.stringify(result.materialCategory));
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setErrors(errs);
                    }

                });
        }
        setLoading(false);
    };

    useEffect(() => {
        getMaterialCategories();
        if (params.id > 0) {
            getDetailsById();
        }
    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!materialCategoryId) {
            isValid = false;
            errs[".materialCategory"] = "Please select material category";
        }
        if (!state.materialsubcategory) {
            isValid = false;
            errs[".materialsubcategory"] = "Please enter material sub category";
        }
        setErrors(errs);
        return isValid;
    }
    const changeHandler = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    };

    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        if (validate()) {
            if (params.id > 0) {
                fetch(
                    service.UPDATE_MATERIAL_SUB_CATEGORY,
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            MaterialSubCategoryId: params.id,
                            MaterialSubCategory: state.materialsubcategory,
                            MaterialCategoryId: materialCategoryId.value,
                            MaterialSubCategoryCode: state.materialsubcategorycode,
                            UpdatedBy: JSON.parse(sessionStorage.getItem('userData')).employeeId,
                        })
                    })
                    .then(res => res.json())
                    .then(result => {
                        if (result.messageType === 'Success') {
                            // eslint-disable-next-line
                            alert(result.message);
                            navigate('/masters/materialsubcategory');
                        }
                        else if (result.messageType === 'Failed') {
                            // eslint-disable-next-line
                            alert(result.message);
                            navigate('/masters/materialsubcategory');
                        }
                        else {
                            errs[".invalid"] = result.message.message;
                            setErrors(errs);
                        }
                    });
            }
            else {
                fetch(
                    service.ADD_MATERIAL_SUB_CATEGORY,
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            MaterialSubCategory: state.materialsubcategory,
                            MaterialCategoryId: materialCategoryId.value,
                            MaterialSubCategoryCode: state.materialsubcategorycode,
                            AddedBy: JSON.parse(sessionStorage.getItem('userData')).employeeId,
                        })
                    })
                    .then(res => res.json())
                    .then(result => {
                        if (result.messageType === 'Success') {
                            // eslint-disable-next-line
                            alert(result.message);
                            navigate('/masters/materialsubcategory');
                        }
                        else if (result.messageType === 'Failed') {
                            // eslint-disable-next-line
                            alert(result.message);
                            navigate('/masters/materialsubcategory');
                        }
                        else {
                            errs[".invalid"] = result.message.message;
                            setErrors(errs);
                        }
                    });
            }
        }
        setLoading(false);
    }
    const backHandler = () => {
        navigate('/masters/materialsubcategory');
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Save Details
                                </MDTypography>
                            </MDBox>
                            <Card style={{ alignItems: 'center' }}>
                                <MDBox pt={4} pb={3} px={3} style={{ width: '50%' }}>
                                    <MDBox component="form" role="form">
                                        <MDBox mb={2} style={{ fontSize: '14px' }}>
                                            <Select
                                                name="materialCategory"
                                                options={materialCategoryData} placeholder="Select Material Category"
                                                value={materialCategoryId}
                                                onChange={ev => setMaterialCategoryId(ev)}
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".materialCategory"]}</div>
                                        </MDBox>
                                        <MDBox mb={2}>
                                            <MDInput label="Material Sub Category" fullWidth value={state.materialsubcategory || ''}
                                                name="materialsubcategory"
                                                onChange={changeHandler}
                                                id="materialsubcategory"
                                                required />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".materialsubcategory"]}</div>
                                        </MDBox>
                                        <MDBox mb={2}>
                                            <MDInput label="Material Sub Category Code" fullWidth value={state.materialsubcategorycode || ''}
                                                name="materialsubcategorycode"
                                                onChange={changeHandler}
                                                id="materialsubcategorycode"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".materialsubcategorycode"]}</div>
                                        </MDBox>
                                        <MDBox mt={4} mb={1} textAlign="center">
                                            {loading ? <Oval
                                                heigth="20"
                                                width="20"
                                                color='grey'
                                                ariaLabel='loading'
                                            /> :
                                                <div>
                                                    <MDButton color="info" onClick={submitHandler}>
                                                        SAVE
                                                    </MDButton>  &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <MDButton color="info" onClick={backHandler}>
                                                        BACK
                                                    </MDButton>
                                                </div>
                                            }
                                            {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                        </MDBox>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default AddEditMaterialSubCategory;